import { useQuery } from '@tanstack/react-query';

import pageRepository from '@/features/pages/repositories/PageRepository';
import { pageKeys } from '@/shared/query/queryKeys';

export function useArchivedPages(collectionId?: string) {
  return useQuery({
    queryKey: pageKeys.archived(collectionId),
    queryFn: () => pageRepository.getArchivedPages(collectionId),
  });
}
